import { useMutation, useQuery } from "@tanstack/react-query";
import {
  createPendingEvidenceQueryKey,
  createPeriodEvidenceQueryKey,
  getPendingIndberetningEvidence,
  getReportEvidenceByPeriod,
  prepareEfteruddannelseIndberetningForSigning,
} from "@/api/efteruddannelseIndberetning";
import type { ReportEvidenceModel } from "@cle/models/reportEvidence";
import type {
  PendingEvidenceResponse,
  PrepareEfteruddannelseIndberetningRequest,
  PrepareEfteruddannelseIndberetningResponse,
} from "@/interfaces/efteruddannelseIndberetning";

export {
  createPendingEvidenceQueryKey,
  createPeriodEvidenceQueryKey,
  EFT_INDBERETNING_QUERY_KEY,
} from "@/api/efteruddannelseIndberetning";

export type {
  PendingEvidenceResponse,
  PrepareEfteruddannelseIndberetningRequest,
  PrepareEfteruddannelseIndberetningResponse,
} from "@/interfaces/efteruddannelseIndberetning";

export const usePrepareEfteruddannelseIndberetningForSigning = () =>
  useMutation<
    PrepareEfteruddannelseIndberetningResponse,
    Error,
    PrepareEfteruddannelseIndberetningRequest
  >({
    mutationFn: prepareEfteruddannelseIndberetningForSigning,
  });

export const usePendingIndberetningEvidence = (
  indberetningId?: string | null,
) =>
  useQuery<PendingEvidenceResponse>({
    queryKey: createPendingEvidenceQueryKey(indberetningId ?? ""),
    queryFn: () => getPendingIndberetningEvidence(indberetningId as string),
    enabled: Boolean(indberetningId),
    staleTime: 5 * 60 * 1000,
  });

export const useReportEvidenceByPeriod = (periodId?: string | null) =>
  useQuery<ReportEvidenceModel[]>({
    enabled: Boolean(periodId),
    queryKey: createPeriodEvidenceQueryKey(periodId as string),
    queryFn: () => getReportEvidenceByPeriod(periodId as string),
    staleTime: 5 * 60 * 1000,
  });
